import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

//避免导航重复
const routerRePush = VueRouter.prototype.push
VueRouter.prototype.push = function (location) {
  return routerRePush.call(this, location).catch(error => error)
}


const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },

  {
    path: '/news',
    name: 'news',
    component: () => import('../views/newsInformation/index1.vue')
  },
  {
    path: '/news2',
    name: 'news2',
    component: () => import('../views/newsInformation/index2.vue')
  },
  {
    path: '/news3',
    name: 'news3',
    component: () => import('../views/newsInformation/index3.vue')
  },
  {
    path: '/news4',
    name: 'news4',
    component: () => import('../views/newsInformation/index4.vue')
  },
  {
    path: '/news5',
    name: 'news5',
    component: () => import('../views/newsInformation/index5.vue')
  },
  {
    path: '/news6',
    name: 'news6',
    component: () => import('../views/newsInformation/index6.vue')
  },
  {
    path: '/newDetails',
    name: 'newDetails',
    component: () => import('../views/newsInformation/newDetails.vue')
  },
  {
    path: '/exhibition',
    name: 'exhibition',
    component: () => import('../views/exhibition/index.vue')
  },
  {
    path: '/exhibitionDetails',
    name: 'exhibitionDetails',
    component: () => import('../views/exhibition/exhibitionDetails.vue')
  },
  {
    path: '/exchange',
    name: 'message',
    component: () => import('../views/exchange/message.vue')
  },
  {
    path: '/contactUS',
    name: 'contactUS',
    component: () => import('../views/exchange/partners.vue')
  },
  {
    path: '/support',
    name: 'support',
    component: () => import('../views/exchange/about-us.vue')
  },
  {
    path: '/aftersales',
    name: 'aftersales',
    component: () => import('../views/exchange/contact-us.vue')
  },
  {
    path: '/join',
    name: 'join',
    component: () => import('../views/exchange/join-us.vue')
  },
  {
    path: '/noticeDetails',
    name: 'noticeDetails',
    component: () => import('../views/notice/noticeDetails.vue')
  },
  {
    path: '/publicList',
    name: 'publicList',
    component: () => import('../views/publicList/publicList.vue')
  },
  {
    path: '/publicDetails',
    name: 'publicDetails',
    component: () => import('../views/publicList/publicDetails.vue')
  },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: () => import('../views/user/login.vue')
  // },
  // {
  //   path: '/register',
  //   name: 'register',
  //   component: () => import('../views/user/register.vue')
  // }

]

const router = new VueRouter({
  routes,
})

export default router
